import React, { useEffect, useState } from 'react';

import { Col, Divider, Form, Input, Modal, Row } from 'antd';
import UserProfileForm from './ProfileForm';
import MyButton from './Button';
import CustomerForm from './CustomerForm';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { mockCustomer } from './CustomerList';
import CustomerModal from './CustomerModal';
import CustomerAddressModal from './CustomerAddressModal';
import { CustomerAddressListItem, mockAddress } from './CustomerAddressList';
import _ from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';

// import { useState } from "react";

const CustomerListItem = (props) => {
  const isDesktop = useIsDesktop();

  const { address: addressInfo, handleClickCustomer } = props;
  const { label, address, customerAddressBookId } = addressInfo;

  return (
    <div className='d-flex align-items-center' style={{ cursor: 'pointer' }} onClick={() => handleClickCustomer(customerAddressBookId)}>
      {/* <div className="d-flex" style={{ flex: "1" }} onClick={onClickView}> */}
      <Row
        className='w-100'
        // className={`${isDesktop ? "px-5 py-4" : "px-2 py-3"} `}
        // gutter={{ xs: 8, lg: 16 }}
      >
        <Col span={isDesktop ? 7 : 24}>
          <Typography isBold className={`${isDesktop ? '' : 'pb-2'}`}>
            {label}
          </Typography>
        </Col>
        <Col span={isDesktop ? 16 : 24} className='d-flex'>
          <Typography className='px-3'>{address}</Typography>
          {/* <Typography>{remark}</Typography> */}
        </Col>
        {/* {isDesktop && (
          <Col span={6}>
            <Typography>{remark}</Typography>
          </Col>
        )} */}
      </Row>
    </div>
  );
};

const SelectAddrModal = (props) => {
  const {
    isOpen,
    onCancle,
    addressData,
    setIsOpenSelectAddr,
    setAddressData,
    setEvent,
    formCustomer,
    isOrder,
    setIsOrder,
    contactData,
    tempDataAdd,
    setTempDataAdd,
    handleSelectAddress,
  } = props;

  const isDesktop = useIsDesktop();

  const [form] = Form.useForm();

  const [isOpenAddrModal, setIsOpenAddrModal] = useState(false);
  const [selectArea, setSelectArea] = useState(false);
  const [isTemp, setIsTemp] = useState(true);
  const [tempSearchArray, setTempSearchArray] = useState([]);
  const [formSearch] = Form.useForm();
  const [isSelect, setIsSelect] = useState(false);
  const intl = useIntl();
  const [addressArea, setAddressArea] = useState();

  // //console.log('AddressData', contactData);

  useEffect(() => {
    // setEvent((current) => !current);
    if (isTemp === false) {

      handleTempCreate();
    } else {
      setTempSearchArray(addressData);
    }
  }, [isOpen, addressData]);

  const handleTempCreate = () => {
    if (_.size(tempDataAdd) > 0) {

      if (_.findIndex(addressData, { customerAddressBookId: _.get(_.findLast(tempDataAdd), 'ccustomerAddressBookId') }) === -1) {
        const newData = [...addressData, _.findLast(tempDataAdd)];
        setAddressData(newData)
        setTempSearchArray(newData);
      }
    } else {
      setTempSearchArray(addressData);
    }
  };

  const handleCancelAddrForm = () => {
    form.resetFields();
    setIsOpenAddrModal(false);
    setIsOpenSelectAddr(true);
  };

  const handleSerchAddress = (values) => {

    if (values === '') {
      setTempSearchArray([]);
      setTempSearchArray(addressData);
    } else {
      // setContactSearch(values);
      // customerContactName
      const Search = _.filter(addressData, (item) => {
        return item.addressName.indexOf(values) > -1 || item.address.indexOf(values) > -1;
      });


      setTempSearchArray(Search);
    }
  };

  const handleClickCustomer = (values) => {

    formCustomer.setFieldsValue({
      address: values,
    });
    handleSelectAddress(values, addressData);
    setIsOrder(false);
    setIsOpenSelectAddr(false);
  };

  // const handleClickEdit = () => {
  //   setIsEdit(true);
  // };

  //   const handleClickSave = () => {
  //     // setIsEdit(false);
  //     onCancle();
  //   };

  const handleClickCancel = () => {

    onCancle();
    setIsOrder(false);
    formSearch.resetFields();
  };

  const handleClickCreate = () => {
    setIsOpenAddrModal(true);
    onCancle();
  };

  //       <CustomerAddressModal
  //         isOpen={isOpenCustomerAddressModal}
  //         onCancle={handleCancelCustomerAddressForm}
  //         isEdit={isEdit}
  //       />

  return (
    <>
      <Modal
        title={
          <Typography color={COLORS.Primary} isBold size='16px' className='pb-3'>
            <FormattedMessage id='modalSelectAddress' defaultMessage='Select Address' />
          </Typography>
        }
        open={isOpen}
        onOk={() => {}}
        onCancel={() => handleClickCancel()}
        width={750}
        centered={isDesktop}
        zIndex={9999}
        maskClosable={false}
        footer={[
          <MyButton
            // key="back"
            isPrimary
            onClick={() => handleClickCancel()}
            style={{
              width: isDesktop ? '25%' : '100%',
            }}
            // onClick={isEdit ? handleClickCancelEdit : onCancle}
          >
            <FormattedMessage id='btnClose' defaultMessage='Close' />
          </MyButton>,
        ]}
      >
        <Divider className='m-0' />
        <div>
          <div className='d-flex py-4 mb-2'>
            <Form style={{ width: '100%' }} name='x' form={formSearch}>
              <Form.Item name='name'>
                <Input
                  style={{
                    borderRadius: '20px',
                  }}
                  onChange={(e) => handleSerchAddress(e.target.value)}
                  placeholder={intl.formatMessage({ id: 'placeholderSearchAddress', defaultMessage: 'Search Address' })}
                  suffix={
                    <div>
                      <SearchOutlined
                        style={{
                          color: 'rgba(0,0,0,.45)',
                        }}
                      />
                    </div>
                  }
                />
              </Form.Item>
            </Form>
            <MyButton
              className='ml-3'
              isPrimary
              // key="back"
              onClick={handleClickCreate}
              // onClick={isEdit ? handleClickCancelEdit : onCancle}
            >
              <span><PlusOutlined />{" "}{isDesktop ? <FormattedMessage id="btnCreate" defaultMessage="Create" /> : ""}</span>
            </MyButton>
          </div>
          {_.map(tempSearchArray, (element, index) => {
            return (
              <>
                {index !== 0 && <Divider className='mx-0 my-3' />}
                <CustomerAddressListItem address={element} handleClickCustomer={handleClickCustomer} isOrder={isOrder} customerData={contactData} />
              </>
            );
          })}
        </div>
        <Divider className='mx-0 mt-4 mb-3' />
      </Modal>
      <CustomerAddressModal
        isOpen={isOpenAddrModal}
        onCancle={handleCancelAddrForm}
        isSaveAddr
        form={form}
        customerData={contactData}
        setSelectArea={setSelectArea}
        setEventAddress={setEvent}
        setIsOpenAddrModal={setIsOpenAddrModal}
        tempDataAdd={tempDataAdd}
        setTempDataAdd={setTempDataAdd}
        setIsTemp={setIsTemp}
        isTemp={isTemp}
        setIsSelect={setIsSelect}
        isSelect={isSelect}
        setAddressArea={setAddressArea}
        addressArea={addressArea}
      />
    </>
  );
};

export default SelectAddrModal;
